import ResourceCard, { Bold, Title } from "./ResourceCard";
import { useQuickStartContext } from "./QuickStartCard";


export default function ApiResources() {
  const { programmingLanguage } = useQuickStartContext();

  return (
    <>
      <ResourceCard
        title={ <Title>Check out <Bold>how to get started</Bold></Title> }
        trackedTitle="Making requests"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}` }
        tracked
      />

      <ResourceCard
        title={ <Title>Use the <Bold>API Endpoint Method</Bold></Title> }
        trackedTitle="API endpoint method"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}/making-requests/api-endpoint-method` }
        tracked
      />

      <ResourceCard
        title={ <Title>Scrape more successful with the <Bold>Async method</Bold></Title> }
        trackedTitle="Async requests method"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}/making-requests/async-requests-method` }
        tracked
      />

      <ResourceCard
        title={ <Title>Use one of the <Bold>Structured Data Endpoints</Bold></Title> }
        trackedTitle="Structured data collection method"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}/making-requests/structured-data-collection-method` }
        tracked
      />

      <ResourceCard
        title={ <Title>Learn more about the <Bold>Proxy Port Method</Bold></Title> }
        trackedTitle="Proxy port method"
        linkHref={ `https://docs.scraperapi.com/${programmingLanguage}/making-requests/proxy-port-method` }
        tracked
      />
    </>
  );
};
